export var Unit;
(function (Unit) {
    Unit["km"] = "km";
    Unit["mi"] = "mi";
})(Unit || (Unit = {}));
export var Source;
(function (Source) {
    Source["AccuTrade"] = "AccuTrade";
    Source["TradePending"] = "TradePending";
    Source["Manual"] = "Manual";
    Source["Subaru"] = "Subaru Guaranteed Trade Program";
})(Source || (Source = {}));
